module.exports = __webpack_public_path__ + "static/img/sphere_global.7e40efde.png";